import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../../../common/decorators';
import { ButtonAction } from '../../../action-button';
import { ProfileReportItem } from '../../../../store/models';
import { IconNames, MAX_FIELD_WARNING_COUNT_EXPORT } from '../../../../common/constants';

@Component({
  selector: 'ui-mat-chips-report-columns-dialog',
  templateUrl: './mat-chips-report-columns-dialog.component.html',
  styleUrls: ['./mat-chips-report-columns-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class MatChipsReportColumnsDialogComponent implements OnInit {
  subscriptions: Subscription[] = [];
  buttonAction = ButtonAction;
  formArray: UntypedFormArray;
  selectedFieldsCount: number;
  iconNameList = IconNames;
  readonly maxFieldsWarningCount = MAX_FIELD_WARNING_COUNT_EXPORT;

  constructor(
    public dialogRef: MatDialogRef<MatChipsReportColumnsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      filterName: string;
      label: string;
      filtersFormControlOrGroup: UntypedFormGroup | UntypedFormControl;
      reportItemList: ProfileReportItem[];
      maxFieldsCount: number;
    },
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.initCodeListForm(this.data.reportItemList);
    this.subscriptions.push(
      this.formArray.valueChanges.subscribe(() => {
        this.selectedFieldsCount = this.formArray.value.filter((item: ProfileReportItem) => item.isSelected).length;
      }),
    );
  }

  apply(): void {
    const selectedItems = this.formArray.value.filter((item: ProfileReportItem) => item.isSelected);

    this.dialogRef.close({ selectedItems });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private initCodeListForm(items: ProfileReportItem[]): void {
    this.formArray = this.fb.array([]);
    items.forEach((item: ProfileReportItem) => {
      this.formArray.push(
        new UntypedFormGroup({
          isSelected: new UntypedFormControl(
            Boolean(
              this.data?.filtersFormControlOrGroup.value.some(
                (controlValueItem: ProfileReportItem) => controlValueItem.value === item.value,
              ),
            ),
          ),
          value: new UntypedFormControl(item.value),
          title: new UntypedFormControl(item.title),
          required: new UntypedFormControl(item.required),
        }),
      );
    });
  }
}
